import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { ControlcenterMelcoModelsLocaleStringListItem } from "melco-shared-logic";
import { EditLocaleStringForm } from "../form/EditLocaleStringForm";
import { LocaleStringsListFiltersType } from "../../../hooks/localestrings/LocaleStringsListFilterType";

// const Right = styled(Space)`
//   display: flex;
//   flex-direction: column
//   align-items: flex-end;
// `;

type EditLocaleStringDrawerProps = {
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;
  LocaleStringDetails: ControlcenterMelcoModelsLocaleStringListItem;
  localeStringsListFiltersValues: LocaleStringsListFiltersType | undefined;
};

export const EditLocaleStringDrawer: React.FC<EditLocaleStringDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
  LocaleStringDetails,
  localeStringsListFiltersValues,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      title={t("localestrings.actions.update.title")}
      placement="right"
      width={500}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: "32px" }}
    >
      {isDrawerOpen && (
        <EditLocaleStringForm
          localeStringsListFiltersValues={localeStringsListFiltersValues}
          onCloseDrawer={setDrawerOpen}
          LocaleStringDetails={LocaleStringDetails}
          localeStringId={LocaleStringDetails?.id ?? ""}
        />
      )}
    </Drawer>
  );
};
